export const Abstract08Icon = () => {
  return (
    <svg
      width="125"
      height="125"
      viewBox="0 0 125 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M107.636 62.0438C136.43 62.0438 123.211 87.3779 99.5332 77.5711C123.211 87.3779 114.643 114.643 94.2818 94.2824C114.643 114.643 87.3777 123.212 77.5709 99.5338C87.3777 123.212 62.0436 136.431 62.0436 107.636C62.0436 136.431 36.7091 123.212 46.5159 99.5338C36.7091 123.212 9.44396 114.643 29.805 94.2824C9.44396 114.643 0.875841 87.3779 24.5536 77.5711C0.875841 87.3779 -12.3435 62.0438 16.4516 62.0438C-12.3435 62.0438 0.875841 36.7097 24.5536 46.5165C0.875841 36.7097 9.44396 9.44417 29.805 29.8053C9.44396 9.44417 36.7091 0.876045 46.5163 24.5542C36.7091 0.876045 62.0436 -12.3433 62.0436 16.4518C62.0436 -12.3433 87.3777 0.876411 77.5709 24.5542C87.3777 0.876411 114.643 9.44417 94.2818 29.8053C114.643 9.44417 123.211 36.7097 99.5332 46.5165C123.211 36.7097 136.43 62.0438 107.636 62.0438Z"
        fill="url(#paint0_linear_1866_18425)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18425"
          x1="62.0435"
          y1="0.0436859"
          x2="62.0435"
          y2="124.044"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
